"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.segmentLabel = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
// The wheel drawn as SVG from the cell config (segments, colours, texts, prize pictures): no image to
// import and nothing to download, so it works offline. Segment i is centred at i * (360 / n) +
// segmentOffset degrees clockwise from the top, exactly like wheel2Logic.angleFor stops the pointer.
var C = 500;
var polar = function polar(r, deg) {
  var a = deg * Math.PI / 180;
  return [C + r * Math.sin(a), C - r * Math.cos(a)];
};
var fmt = function fmt(n) {
  return Math.round(n * 100) / 100;
};
var segmentLabel = function segmentLabel(config, i) {
  var style = (config.segmentStyles || [])[i] || {};
  if (style.label !== undefined && style.label !== '') return style.label;
  var key = config.segments[i];
  return key && config.prizes[key] ? config.prizes[key].label || key : config.wheel.loseLabel;
};
exports.segmentLabel = segmentLabel;
var Wheel2Disc = function Wheel2Disc(_ref) {
  var config = _ref.config,
    _ref$uriTransformer = _ref.uriTransformer,
    uriTransformer = _ref$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref$uriTransformer,
    style = _ref.style,
    className = _ref.className;
  var w = config.wheel;
  var n = config.segments.length;
  var rim = Number(w.borderWidth) || 0;
  var R = C - rim;
  var seg = n ? 360 / n : 360;
  var palette = w.colors && w.colors.length ? w.colors : [{
    bg: '#cccccc',
    text: '#000000'
  }];
  var offset = Number(config.segmentOffset) || 0;
  var font = {
    fontFamily: w.fontFamily || 'inherit',
    fontWeight: w.fontWeight || 'bold'
  };
  var segments = config.segments.map(function (key, i) {
    var st = (config.segmentStyles || [])[i] || {};
    var pal = palette[i % palette.length];
    var bg = st.bg || pal.bg;
    var text = st.text || pal.text;
    var center = i * seg + offset;
    var a1 = center - seg / 2;
    var a2 = center + seg / 2;
    var _polar = polar(R, a1),
      _polar2 = _slicedToArray(_polar, 2),
      x1 = _polar2[0],
      y1 = _polar2[1];
    var _polar3 = polar(R, a2),
      _polar4 = _slicedToArray(_polar3, 2),
      x2 = _polar4[0],
      y2 = _polar4[1];
    var d = n === 1 ? "M ".concat(C, " ").concat(C - R, " A ").concat(R, " ").concat(R, " 0 1 1 ").concat(C, " ").concat(C + R, " A ").concat(R, " ").concat(R, " 0 1 1 ").concat(C, " ").concat(C - R, " Z") : "M ".concat(C, " ").concat(C, " L ").concat(fmt(x1), " ").concat(fmt(y1), " A ").concat(R, " ").concat(R, " 0 ").concat(seg > 180 ? 1 : 0, " 1 ").concat(fmt(x2), " ").concat(fmt(y2), " Z");
    var label = w.showLabels ? segmentLabel(config, i) : '';
    var lines = String(label).split('|');
    var longest = Math.max.apply(Math, [1].concat(_toConsumableArray(lines.map(function (l) {
      return l.length;
    }))));
    // keep the text inside the segment: shrink long labels, and narrow segments
    var hubR = w.hub.show ? (Number(w.hub.size) || 0) / 2 : 0;
    var radialRoom = Math.max(2 * Math.min(R * (w.textRadius / 100) - hubR - 12, R * (1 - w.textRadius / 100) - 12), 60);
    var arcRoom = 2 * Math.PI * R * (w.textRadius / 100) * seg / 360 * 0.8;
    var size = Math.max(14, Math.min(w.fontSize, radialRoom / (longest * 0.58), arcRoom / lines.length / 1.15));
    var ty = C - R * (w.textRadius / 100);
    var rot = w.textDirection === 'inward' ? 90 : -90;
    var img = st.image_uri;
    var iy = C - R * (w.imageRadius / 100);
    var isz = Number(w.imageSize) || 100;
    return /*#__PURE__*/_react.default.createElement("g", {
      key: i
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: d,
      fill: bg,
      stroke: w.separatorColor,
      strokeWidth: w.separatorWidth,
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react.default.createElement("g", {
      transform: "rotate(".concat(fmt(center), " ").concat(C, " ").concat(C, ")")
    }, lines[0] !== '' && /*#__PURE__*/_react.default.createElement("text", {
      x: C,
      y: ty,
      fill: text,
      fontSize: fmt(size),
      textAnchor: "middle",
      dominantBaseline: "middle",
      style: font,
      transform: "rotate(".concat(rot, " ").concat(C, " ").concat(ty, ")")
    }, lines.map(function (l, k) {
      return /*#__PURE__*/_react.default.createElement("tspan", {
        key: k,
        x: C,
        dy: k === 0 ? "".concat(-(lines.length - 1) * 0.55, "em") : '1.1em'
      }, l);
    })), img && /*#__PURE__*/_react.default.createElement("image", {
      href: uriTransformer(img),
      x: C - isz / 2,
      y: iy - isz / 2,
      width: isz,
      height: isz,
      preserveAspectRatio: "xMidYMid meet"
    })));
  });
  return /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 ".concat(2 * C, " ").concat(2 * C),
    style: _objectSpread({
      display: 'block'
    }, style),
    className: className
  }, rim > 0 && /*#__PURE__*/_react.default.createElement("circle", {
    cx: C,
    cy: C,
    r: C - rim / 2,
    fill: "none",
    stroke: w.borderColor,
    strokeWidth: rim
  }), n === 0 ? /*#__PURE__*/_react.default.createElement("circle", {
    cx: C,
    cy: C,
    r: R,
    fill: palette[0].bg
  }) : segments, w.hub.show && /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("circle", {
    cx: C,
    cy: C,
    r: (Number(w.hub.size) || 100) / 2,
    fill: w.hub.color,
    stroke: w.separatorColor,
    strokeWidth: w.separatorWidth
  }), w.hub.image_uri && /*#__PURE__*/_react.default.createElement("image", {
    href: uriTransformer(w.hub.image_uri),
    x: C - w.hub.size / 2,
    y: C - w.hub.size / 2,
    width: w.hub.size,
    height: w.hub.size,
    preserveAspectRatio: "xMidYMid meet"
  })));
};
var _default = exports.default = Wheel2Disc;